import { connect } from 'react-redux';

import AdminCustomerComponent from './admin-customer.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminCustomerComponent);



// WEBPACK FOOTER //
// ./src/components/admin/customer/admin-customer.ts